import { Notifications, initialState } from './notifications.state';
import { NotificationsActions, NotificationsActionType } from './notifications.actions';

import { NotificationInterface } from '@core/store/models/notifications.interface';
import { Notification } from '@core/store/models/notifications.class';


// import * as Objects from '@core/objects';

export function notificationsReducer(state = initialState, action: NotificationsActions): Notifications {
    switch (action.type) {

        case NotificationsActionType.Add:
            return {...state, items: [...state.items, ...[new Notification(action.context, action.data)]]}
        
        case NotificationsActionType.Hide:
            return {...state, 
                items: [...state.items.map((not: NotificationInterface) => not.id == action.id? {...not, visible: false}: not)]
            }
        case NotificationsActionType.Clear:
            return {...state, ...initialState}

        default:
	        return state;
    }
}
